<template>
  <div>
    <b-card v-if="company != null">
      <div class="col-md-12">
        <div class="mt-2">
          <FrameworkAgreementSeller @save-requested="submit" />
        </div>
      </div>
      <br/>
    </b-card>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import {FormWizard, TabContent} from "vue-form-wizard";
import {ValidationProvider, ValidationObserver} from "vee-validate";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {BButton, BRow} from "bootstrap-vue";
import FrameworkAgreementSeller from "@/components/skribble/FrameworkAgreementSeller.vue";

export default {
  components: {
    BButton, BRow,
    FormWizard,
    TabContent,
    ValidationProvider,
    ValidationObserver,
    FrameworkAgreementSeller,
  },
  data() {
    return {
      company: null,
      showButton: false,
    };
  },
  directives: {
    Ripple,
  },
  created() {
    if (localStorage.getItem("task_status")) {
      let tasks = JSON.parse(localStorage.getItem("task_status"));

      if (tasks == "0") {
        this.showButton = true;
      }
    }

    this.$http
        .post(`/company/show/${this.$store.state.auth.user.company_id}`)
        .then((res) => {
          this.company = res.data.value;
          this.phoneContries = this.company.main_contact.iso_code;
          console.log(this.company);
        });
  },
  methods: {
    submit() {
      document.getElementById("updateSideBar").click();
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
